<script lang="ts">
  import type { SvelteHTMLElements } from 'svelte/elements'

  type Props = {
    color?: string
  } & SvelteHTMLElements['svg']

  let { color = 'currentColor', ...restProps }: Props = $props()
</script>

<svg viewBox="200 220 760 760" xmlns="http://www.w3.org/2000/svg" {...restProps}>
  <path
    d="m665.32 524.55-24.035-24.035v0.003906c-3.125-3.1289-7.3672-4.8867-11.793-4.8867-4.4219 0-8.6641 1.7578-11.793 4.8867l-51.863 51.863-51.863-51.863v-0.003906c-3.1289-3.125-7.3711-4.8828-11.793-4.8828-4.4258 0-8.668 1.7578-11.797 4.8828l-24.035 24.035h0.003907c-3.1289 3.1289-4.8867 7.3711-4.8867 11.793s1.7578 8.6641 4.8867 11.793l51.863 51.863-51.863 51.863v0.003907c-3.1289 3.125-4.8867 7.3672-4.8867 11.793 0 4.4219 1.7578 8.6641 4.8867 11.793l24.035 24.035-0.003906-0.003906c3.1289 3.1289 7.3711 4.8867 11.797 4.8867 4.4219 0 8.6641-1.7578 11.793-4.8867l51.863-51.863 51.863 51.863c3.1289 3.1289 7.3711 4.8867 11.793 4.8867 4.4258 0 8.668-1.7578 11.793-4.8867l24.035-24.031c3.1289-3.1289 4.8828-7.3711 4.8828-11.793 0-4.4258-1.7539-8.668-4.8828-11.793l-51.863-51.867 51.863-51.863c3.1289-3.125 4.8828-7.3672 4.8828-11.793 0-4.4219-1.7539-8.6641-4.8828-11.793z"
    fill={color}
  />

  <path
    d="m247.86 257.46h131.9c3.7461 0 7.3438 1.4883 9.9922 4.1406 2.6523 2.6484 4.1406 6.2461 4.1406 9.9922v131.9c0 7.8047-6.3281 14.129-14.133 14.129h-131.9c-7.8047 0-14.133-6.3242-14.133-14.129v-131.9c0-7.8047 6.3281-14.133 14.133-14.133z"
    fill={color}
  />

  <path
    d="m488.11 257.46h131.9c7.8047 0 14.133 6.3281 14.133 14.133v131.9c0 7.8047-6.3281 14.133-14.133 14.133h-131.9c-3.75 0-7.3438-1.4922-9.9961-4.1406-2.6484-2.6523-4.1367-6.2461-4.1367-9.9922v-131.9c0-7.8047 6.3281-14.133 14.133-14.133z"
    fill={color}
  />

  <path
    d="m728.36 257.46h131.9c3.7461 0 7.3398 1.4883 9.9922 4.1406 2.6484 2.6484 4.1406 6.2461 4.1406 9.9922v131.9c0 7.8047-6.3281 14.129-14.133 14.129h-131.9c-7.8047 0-14.133-6.3242-14.133-14.129v-131.9c0-3.7461 1.4883-7.3438 4.1406-9.9922 2.6484-2.6523 6.2461-4.1406 9.9922-4.1406z"
    fill={color}
  />

  <path
    d="m247.86 782.37h131.9c7.8047 0 14.133 7.8047 14.133 14.133v131.9c0 7.8047-6.3281 14.133-14.133 14.133h-131.9c-7.8047 0-14.133-7.8047-14.133-14.133v-131.9c0-7.8047 6.3281-14.133 14.133-14.133z"
    fill={color}
  />

  <path
    d="m488.11 782.37h131.9c7.8047 0 14.133 6.3281 14.133 14.133v131.9c0 7.8047-6.3281 14.133-14.133 14.133h-131.9c-7.8047 0-14.133-6.3281-14.133-14.133v-131.9c0-7.8047 6.3281-14.133 14.133-14.133z"
    fill={color}
  />

  <path
    d="m728.36 782.37h131.9c7.8047 0 14.133 7.8047 14.133 14.133v131.9c0 7.8047-6.3281 14.133-14.133 14.133h-131.9c-7.8047 0-14.133-7.8047-14.133-14.133v-131.9c0-7.8047 6.3281-14.133 14.133-14.133z"
    fill={color}
  />

  <path
    d="m404.94 536.36c-0.0625-14.676 4.3477-29.023 12.652-41.125h-77.871c-3.75 0-7.3438 1.4883-9.9922 4.1367-2.6523 2.6523-4.1406 6.2461-4.1406 9.9961v181.32c0 3.75 1.4883 7.3438 4.1406 9.9961 2.6484 2.6484 6.2461 4.1367 9.9922 4.1367h77.941c-9.6055-14.074-13.988-31.062-12.402-48.027 1.5859-16.965 9.0469-32.844 21.09-44.895l11.945-11.871-11.941-11.941h-0.003906c-13.754-13.691-21.465-32.312-21.41-51.723z"
    fill={color}
  />

  <path
    d="m952.14 495.23h-238.06c9.5664 14.082 13.922 31.055 12.324 48-1.5977 16.949-9.0547 32.809-21.086 44.848l-11.941 11.941 11.941 11.871c12.043 12.051 19.504 27.93 21.094 44.895 1.5859 16.965-2.8008 33.949-12.402 48.027h238.13c7.793-0.023437 14.109-6.3359 14.129-14.133v-181.32c0.003907-3.75-1.4844-7.3438-4.1367-9.9961-2.6484-2.6484-6.2461-4.1367-9.9922-4.1367z"
    fill={color}
  />
</svg>
